import React from 'react'
import AnimatedText9 from './AnimatedText9'
import { HiMiniXMark } from 'react-icons/hi2'
import logo from '../images/logo.webp';
import iconorange from '../images/icon_orange.svg';

const ComparisonSection = () => {
  return (
    <div>
        <section id="comparison">
                <div className='container-xxl comparison-container'>
                    <div className='headtext' >
                        <div className='text-box' data-aos="fade-up">
                            <img id="comparisonimg" className='icon_orange' src={iconorange} alt='icon-orange' />
                            <p>Comparison</p>
                        </div>

                        <AnimatedText9 />
                    </div>
                    <div className='maincontain'>
                        <div className='row'>
                            <div className='col-6 firstcol'>
                                <div className='box box1'>
                                    <div className='textp'>
                                        <p>Other Agencies</p>
                                    </div>
                                    <div className='subbox'>
                                        <ul>

                                            <li>
                                                <div className='text-li'>
                                                    <div className='icon-xmark'>
                                                        <HiMiniXMark className='xmark' />
                                                    </div>
                                                    <div className='txt'>
                                                        <p>Slow communication</p>
                                                    </div>
                                                </div>
                                            </li>


                                            <li>
                                                <div className='text-li'>
                                                    <div className='icon-xmark'>
                                                        <HiMiniXMark className='xmark' />
                                                    </div>
                                                    <div className='txt'>
                                                        <p>Single person approach</p>
                                                    </div>
                                                </div>
                                            </li>


                                            <li>
                                                <div className='text-li'>
                                                    <div className='icon-xmark'>
                                                        <HiMiniXMark className='xmark' />
                                                    </div>
                                                    <div className='txt'>
                                                        <p>Outdated UI/UX strategies</p>
                                                    </div>
                                                </div>
                                            </li>


                                            <li>
                                                <div className='text-li'>
                                                    <div className='icon-xmark'>
                                                        <HiMiniXMark className='xmark' />
                                                    </div>
                                                    <div className='txt'>
                                                        <p>Lack of industry research</p>
                                                    </div>
                                                </div>
                                            </li>


                                            <li>
                                                <div className='text-li'>
                                                    <div className='icon-xmark'>
                                                        <HiMiniXMark className='xmark' />
                                                    </div>
                                                    <div className='txt'>
                                                        <p>High Charges with Low Quality</p>
                                                    </div>
                                                </div>

                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <div className='col-6 firstcol'>
                                <div className='box box2'>
                                    <div className='imageb'>
                                        <img src={logo} alt='logo' className='img-fluid' />
                                    </div>
                                    <div className='subbox subbox2'>
                                        <ul>

                                            <li>
                                                <div className='text-li'>
                                                    <div className='icon'>
                                                        <svg
                                                            stroke="#FE7201FF" fill="#FE7201FF"
                                                            stroke-width="0" viewBox="0 0 16 16"
                                                            role="presentation" class="r-1qz24ta"
                                                            height="1.3em" width="1.3em"
                                                            xmlns="http://www.w3.org/2000/svg"
                                                        >
                                                            <circle cx="8" cy="8" r="8" fill="#FE7201FF" />
                                                            <path
                                                                d="M12.03 4.97a.75.75 0 0 0-1.08.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-.01-1.05z"
                                                                fill="white"
                                                            ></path>
                                                        </svg>
                                                    </div>
                                                    <div className='txt'>
                                                        <p>Constant, proactive communication</p>
                                                    </div>
                                                </div>
                                            </li>


                                            <li>
                                                <div className='text-li'>
                                                    <div className='icon'>
                                                        <svg
                                                            stroke="#FE7201FF" fill="#FE7201FF"
                                                            stroke-width="0" viewBox="0 0 16 16"
                                                            role="presentation" class="r-1qz24ta"
                                                            height="1.3em" width="1.3em"
                                                            xmlns="http://www.w3.org/2000/svg"
                                                        >
                                                            <circle cx="8" cy="8" r="8" fill="#FE7201FF" />
                                                            <path
                                                                d="M12.03 4.97a.75.75 0 0 0-1.08.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-.01-1.05z"
                                                                fill="white"
                                                            ></path>
                                                        </svg>
                                                    </div>
                                                    <div className='txt'>
                                                        <p>Expertise approach</p>
                                                    </div>
                                                </div>
                                            </li>


                                            <li>
                                                <div className='text-li'>
                                                    <div className='icon'>
                                                        <svg
                                                            stroke="#FE7201FF" fill="#FE7201FF"
                                                            stroke-width="0" viewBox="0 0 16 16"
                                                            role="presentation" class="r-1qz24ta"
                                                            height="1.3em" width="1.3em"
                                                            xmlns="http://www.w3.org/2000/svg"
                                                        >
                                                            <circle cx="8" cy="8" r="8" fill="#FE7201FF" />
                                                            <path
                                                                d="M12.03 4.97a.75.75 0 0 0-1.08.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-.01-1.05z"
                                                                fill="white"
                                                            ></path>
                                                        </svg>
                                                    </div>
                                                    <div className='txt'>
                                                        <p>Tailored best-fit solutions</p>
                                                    </div>
                                                </div>
                                            </li>


                                            <li>
                                                <div className='text-li'>
                                                    <div className='icon'>
                                                        <svg
                                                            stroke="#FE7201FF" fill="#FE7201FF"
                                                            stroke-width="0" viewBox="0 0 16 16"
                                                            role="presentation" class="r-1qz24ta"
                                                            height="1.3em" width="1.3em"
                                                            xmlns="http://www.w3.org/2000/svg"
                                                        >
                                                            <circle cx="8" cy="8" r="8" fill="#FE7201FF" />
                                                            <path
                                                                d="M12.03 4.97a.75.75 0 0 0-1.08.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-.01-1.05z"
                                                                fill="white"
                                                            ></path>
                                                        </svg>
                                                    </div>
                                                    <div className='txt'>
                                                        <p>Provides industry-specific expertise</p>
                                                    </div>
                                                </div>
                                            </li>


                                            <li>
                                                <div className='text-li'>
                                                    <div className='icon'>
                                                        <svg
                                                            stroke="#FE7201FF" fill="#FE7201FF"
                                                            stroke-width="0" viewBox="0 0 16 16"
                                                            role="presentation" class="r-1qz24ta"
                                                            height="1.3em" width="1.3em"
                                                            xmlns="http://www.w3.org/2000/svg"
                                                        >
                                                            <circle cx="8" cy="8" r="8" fill="#FE7201FF" />
                                                            <path
                                                                d="M12.03 4.97a.75.75 0 0 0-1.08.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-.01-1.05z"
                                                                fill="white"
                                                            ></path>
                                                        </svg>
                                                    </div>
                                                    <div className='txt'>
                                                        <p>Fair Charges with Notch Quality</p>
                                                    </div>
                                                </div>
                                            </li>

                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
    </div>
  )
}

export default ComparisonSection